export default __webpack_public_path__ + "static/media/chat-icon.64b20e7b.svg";